import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import { RollbarService } from 'angular-rollbar';
import { ENV } from '../../environment';

@Injectable()
export class RollBarLogService extends LogService {
  private levels = {
    'DEBUG': 1,
    'INFO': 2,
    'WARN': 3,
    'ERROR': 4
  };

  constructor(private rollbar: RollbarService) {
    super();
  }

  shouldLog(level: string): boolean {
    return this.levels[level] >= this.levels[ENV.LogLevel];
  }

  log(msg: string) {
    if (this.shouldLog('INFO')) {
      this.rollbar.info(msg);
      super.log(msg);
    }
  }

  error(msg: string) {
    if (this.shouldLog('ERROR')) {
      this.rollbar.error(msg);
      super.error(msg);
    }
  }

  warn(msg: string) {
    if (this.shouldLog('WARN')) {
      this.rollbar.warn(msg);
      super.warn(msg);
    }
  }
}
